<template>
    <b-modal id="modal-add-enterprise-connection" title="Add Enterprise Connection">
        Note: Your connection must be approved by the Enterprise company

        <div>
            <template v-if="typeof errors.url !== 'undefined'">
                <span class="form__error" v-for="(error, index) in errors.url" :key="index">{{error}}</span>
            </template>
        </div>

        <template #modal-footer>
            <b-button variant="primary" size="lg" :disabled="loading" @click="add">
                <span v-if="!loading">Send Connection Request</span>
                <span v-else><b-spinner class="mr-1" small></b-spinner>Loading...</span>
            </b-button>
        </template>
    </b-modal>
</template>

<script>

import enterprises from "@/services/ecosystem/enterprises.service"
import Vue from 'vue';

export default {

    data() {
        return {
            id: 0,

            errors: {},
            result: "",
            loading: false,
        }
    },

    methods: {
        open(id) {
            this.id = id
            this.$bvModal.show('modal-add-enterprise-connection')
        },

        add() {
            this.loading = true
            this.errors = {}
            this.result = ""

            let data = {
                id: this.id,
            }

            enterprises.addConnection(data).then(response => {
                this.loading = false
                this.errors = response.data.errors
                this.result = response.data.result

                if (!Object.keys(this.errors).length) {
                    this.$bvModal.hide('modal-add-enterprise-connection');
                    this.$emit('connectionAdded')

                    this.$store.commit('setNeedUpdateEnterprises', true);

                    Vue.notify({
                        group: 'app',
                        type: 'success',
                        duration: 5000,
                        text: response.data.result
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>